import React, { useState, useEffect } from 'react'

import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";
import { DatePicker } from '@material-ui/pickers';

import { gql, useApolloClient } from '@apollo/client';
import { useDispatch } from 'react-redux';

import { AddBPMApplicationMessages } from '../../../redux/reducers/BPMReducer';
import BPMDialog from '../../../components/BPMTable/TableComponents/Dialogs/BPMDialog';
import { getNextDayPlainDateString, getTodayDateString, parsePlainDate, toPlainDateString } from '../../../utils/DateUtils';

const UN_HOLD = gql`
    mutation(
        $id: String!,
        $validSince: Date!,
        $expirationDate: Date!,
    ){
        bayphoneUnHold(
            id: $id,
            validSince: $validSince,
            expirationDate: $expirationDate,
        ) {
      bayphone {
        id
      }
    }
  }
`;

const BayphoneUnHoldDialog = props => {
  const [isLoading, setLoading] = useState(false);

  const { open, handleClose, selectedRows, t } = props;

  const [validSince, setValidSince] = useState('');
  const [expirationDate, setExpirationDate] = useState('');

    const dispatch = useDispatch()
    const client = useApolloClient()

  useEffect(() => {
    return () => {
      setLoading(false);
      setValidSince('');
      setExpirationDate('');
    };
  }, []);

  const onClickProcess = () => {
        setLoading(true)

        client.mutate({
        mutation: UN_HOLD,
        variables: {
          id: selectedRows[0].id,
          validSince: validSince,
          expirationDate: expirationDate,
        },
      })
      .then(result => {
        const success = result.data;

        if (success) {
                handleQueryExecuted(true, t("State change successfully executed"));
            } else {;
          handleQueryExecuted(false, t('An error occurred while changing the state of the Bayphone'));
        }
      })
      .catch(error => {
            handleQueryExecuted(false, JSON.stringify(error))
        })
        .finally(() => {
          setLoading(false);
        });
  };

  const createApplicationMessage = (text, variant) => {
        dispatch(AddBPMApplicationMessages({
        text: text,
        duration: 8000,
        variant: variant,
        }))
    }

  const handleQueryExecuted = (success, message) => {
    createApplicationMessage(message, success ? 'success' : 'error');
    setLoading(false);
    onCloseDialog();
    }

  const onCloseDialog = () => {
        setValidSince(null)
        setExpirationDate('')
    handleClose();
    }

  const submitable = () => {
        return (validSince && expirationDate && isLoading === false)
    }

  const handleValidSinceChange = date => {
    const newValidSince = toPlainDateString(date) || '';
    setValidSince(newValidSince);

    if (newValidSince && expirationDate) {
      const minExpirationDateFormatted = getNextDayPlainDateString(newValidSince);

      if (expirationDate < minExpirationDateFormatted) {
        setExpirationDate('');
      }
    }
    }

  const handleExpirationDateChange = date => {
    setExpirationDate(toPlainDateString(date) || '');
  };

  const minExpirationDateFormatted = validSince ? getNextDayPlainDateString(validSince) : null;
  const todayDate = parsePlainDate(getTodayDateString());

  return (
    <BPMDialog
      open={open}
      onClose={onCloseDialog}
        maxWidth='md'
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
    >
            <DialogTitle id='alert-dialog-title'>
                <span onClick={(event, reason) => onCloseDialog(event, reason)} style={{fontSize: '1.5em',  cursor: 'pointer', position: 'absolute', right: '5px', top: '-5px'}}>&times;</span>
        {t('bayphone:Bayphone')}
      </DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <DatePicker
            label={t('bayphone:Valid since')}
            value={validSince ? parsePlainDate(validSince) : null}
            onChange={handleValidSinceChange}
            minDate={todayDate}
            inputVariant='outlined'
            format='P'
            style={{ width: 250, marginBottom: 16 }}
          />
          <DatePicker
            label={t('bayphone:Expiration date')}
            value={expirationDate ? parsePlainDate(expirationDate) : null}
            onChange={handleExpirationDateChange}
            minDate={minExpirationDateFormatted ? parsePlainDate(minExpirationDateFormatted) : todayDate}
            disabled={!validSince}
            inputVariant='outlined'
            format='P'
            style={{ width: 250 }}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <div>
                    <Button
                        style={{ marginRight: 20 }}
                        onClick={onCloseDialog}
                        variant='contained'
                        disabled={isLoading}
                    >
            {t('bayphone:Cancel')}
          </Button>
                    <Button
                        onClick={onClickProcess}
                        variant='contained'
                        color='primary'
                        disabled={!submitable()}
                    >
            {t('bayphone:UnHold')}
          </Button>
        </div>
      </DialogActions>
    </BPMDialog>
    )
};

export default BayphoneUnHoldDialog;
